<template>
	<div>
		<p class="font-70 type-500 mb-2">
			<slot></slot>
		</p>
		<ul :class="['-mx-1 flex h-2 mb-8', { 'md:h-1': inline }]">
			<li v-for="n in [0, 1, 2]" :key="n" class="px-1 flex-1">
				<span
					:class="[
						'block w-full h-full',
						[bars > n ? 'bg-secondary' : 'bg-mono-200 opacity-25'],
					]"
				></span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			bars: null,
		}
	},
	props: {
		inline: {
			type: Boolean,
		},
		percentage: {
			type: Number,
			required: true,
		},
	},
	created: function () {
		this.bars = Math.round(3 * (this.percentage / 100))
	},
}
</script>
